module.exports = __webpack_public_path__ + "static/img/logo-MELBOURNE.b7a84f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-MELBOURNE.svg
// module id = HGa0
// module chunks = 1